// models/Del/utils/delClientSignatureValidation.js
// Del Client Signature Validation

// Draft validation
export const validateDelClientSignaturesDraft = (delClientSignaturesInfo) => {
  const errors = [];

  // Going through each non employee signature info
  delClientSignaturesInfo.forEach((clientSignature) => {
    // Creating a non employee signature info error object
    const clientSignatureError = {
      rowId: clientSignature.rowId,
      errors: {
        clientEmpName: "",
        clientCompanyName: "",
        clientEmpSig: "",
      },
    };

    // Checking if the client employee name is empty
    if (
      !clientSignature.clientEmpName ||
      clientSignature.clientEmpName === ""
    ) {
      clientSignatureError.errors.clientEmpName = "Name is required";
    }

    // Checking if the client employee company is empty
    if (
      !clientSignature.clientCompanyName ||
      clientSignature.clientCompanyName === ""
    ) {
      clientSignatureError.errors.clientCompanyName =
        "Company name is required";
    }

    if (
      clientSignatureError.errors.clientEmpName ||
      clientSignatureError.errors.clientCompanyName
    ) {
      errors.push(clientSignatureError);
    }
  });

  return errors;
};

// Submitted validation
export const validateDelClientSignaturesSubmitted = (
  delClientSignaturesInfo
) => {
  const errors = [];
  // Going through each client signature info
  delClientSignaturesInfo.forEach((clientSignature) => {
    // Creating a client signature info error object
    const clientSignatureError = {
      rowId: clientSignature.rowId,
      errors: {
        clientEmpName: "",
        clientCompanyName: "",
        clientEmpSig: "",
      },
    };

    // Checking if the client employee name is empty
    if (
      !clientSignature.clientEmpName ||
      clientSignature.clientEmpName === ""
    ) {
      clientSignatureError.errors.clientEmpName = "Employee name is required";
    }

    // Checking if the client company is empty
    if (
      !clientSignature.clientCompanyName ||
      clientSignature.clientCompanyName === ""
    ) {
      clientSignatureError.errors.clientCompanyName =
        "Company name is required";
    }

    // Checking if the client employee signature is empty
    if (!clientSignature.clientEmpSig || clientSignature.clientEmpSig === "") {
      clientSignatureError.errors.clientEmpSig =
        "Employee signature is required";
    }

    if (
      clientSignatureError.errors.clientEmpName ||
      clientSignatureError.errors.clientCompanyName ||
      clientSignatureError.errors.clientEmpSig
    ) {
      errors.push(clientSignatureError);
    }
  });

  return errors;
};
